import { AlertCircle } from 'lucide-react'
import { Button } from './Button'

interface Props {
  message?: string
  onRetry?: () => void
}

export function ErrorCard({ message = 'Что-то пошло не так', onRetry }: Props) {
  return (
    <div className="bg-surface-1 border border-line-1 rounded-lg p-6 flex flex-col items-center gap-4 text-center">
      <AlertCircle size={28} className="text-danger opacity-60" />
      <p className="text-base text-ink-1">{message}</p>
      {onRetry && (
        <Button variant="ghost" size="sm" onClick={onRetry}>
          Попробовать снова
        </Button>
      )}
    </div>
  )
}
